



"use strict";




export default class PageHeader {

    constructor () {
        this.subMenu = document.querySelectorAll('.submenu');

        this.setSubMenuEvents();
        this.setSearchEvents();
        this.setScrollEvents();
    }

    menuItemHasSubMenu (item) {
        return document.querySelector(`.submenu[data-parent-id="${item.dataset.id}"]`) != null;
    }

    isSubMenuHover () {
        return Array.from(document.querySelectorAll(":hover"))
            .filter(item =>
                item.classList.contains('menu-item') &&
                this.menuItemHasSubMenu(item)
            ).length > 0;
    }

    hideSubMenu () {
        this.subMenu
            .forEach(submenu => submenu.classList.remove('active'));
    }

    setSubMenuEvents() {
        document.querySelectorAll('.main-nav > .menu-item')
            .forEach(menuItem => {
                menuItem.addEventListener('mouseenter', () => {
                    this.hideSubMenu();
                    const iId = menuItem.dataset.id;
                    const subMenu = document.querySelector('.submenu[data-parent-id="'+iId+'"]');
                    if (subMenu) {
                        subMenu.classList.add('active');
                    }
                })

                menuItem.addEventListener('mouseleave', evt => {
                    if (
                        this.isSubMenuHover() &&
                        this.menuItemHasSubMenu(evt.currentTarget)
                    ) {
                        this.subMenu
                            .forEach(submenu => submenu.classList.add('noslide'));
                    } else {
                        this.subMenu
                            .forEach(submenu => submenu.classList.remove('noslide'));
                    }
                    this.hideSubMenu();
                });
            }
        );

        this.subMenu
            .forEach(subMenu => {
                subMenu.addEventListener('mouseover', () => {
                    subMenu.classList.add('active');
                });

                subMenu.addEventListener('mouseout', () => {
                    this.hideSubMenu();
                })
            });
    }

    setSearchEvents () {
        /*
        document.querySelector('.search-btn').addEventListener('click', () => {
            if ( document.querySelector('.main-nav').classList.contains('search') ) {
                 document.querySelector('.searchform').submit();
            } else {
                document.querySelector('.main-nav').classList.add('search');
                document.querySelector('.searchfield').focus();
            }
        });
        */



        /*
        document.querySelector('.searchform-overlay').addEventListener('click', () => {
            document.querySelector('.main-nav').classList.remove('search');
        });
        */

        const toggleClearBtn = evt => {
            if (!evt.currentTarget.value) {
                document.querySelector('.clear-btn').classList.remove('active');
            } else {
                document.querySelector('.clear-btn').classList.add('active');
            }
        }

        if ( document.querySelector('.searchfield') ) {
            document.querySelector('.searchfield').addEventListener('keyup', toggleClearBtn);
            document.querySelector('.searchfield').addEventListener('change', toggleClearBtn);
        }


        if ( document.querySelector('.clear-btn') ) {
            document.querySelector('.clear-btn').addEventListener('click', () => {
                document.querySelector('.searchfield').value = '';
                document.querySelector('.searchfield').focus();
                document.querySelector('.clear-btn').classList.remove('active');
            });
        }
    }


    setScrollEvents () {
        const eDocument = document.documentElement;
        const eTopHolder = document.querySelector('.header-top-holder');
        const eMainNavHolder = document.querySelector('.main-nav-holder');
        const aSubMenus = document.querySelectorAll('.top-bar .submenu');
        const notificationBar = document.querySelector('.notification');

        if (!eMainNavHolder) return;

        const setMainNavPos = () => {
            const iHeaderOffsetTop = eMainNavHolder.offsetTop;
            const iHeaderHeight = eMainNavHolder.offsetHeight;
            const iDocumentOffsetTop =
                (window.pageYOffset || eDocument.scrollTop)
                - (eDocument.clientTop || 0);
            const iTopHeight = eTopHolder.getBoundingClientRect().height || 0;

            if ( iDocumentOffsetTop > iTopHeight) {
                eMainNavHolder.style.position = 'fixed';
                eMainNavHolder.classList.add('fixed');
                //eTopHolder.style.marginBottom = iHeaderHeight +20+'px';
                eDocument.style.paddingTop = iHeaderHeight +20+'px';

                if ( notificationBar ) {
                    notificationBar.classList.remove('active');
                }

                aSubMenus.forEach(subMenu => {
                    subMenu.style.position = 'fixed';
                    subMenu.style.top = iHeaderHeight +'px';
                });
            } else {
                eMainNavHolder.style.position = 'relative';
                eMainNavHolder.classList.remove('fixed');
                //eTopHolder.style.marginBottom = 0;
                eDocument.style.paddingTop = 0;
                aSubMenus.forEach(subMenu => {
                    subMenu.style.position = 'absolute';
                    subMenu.style.top = '100%';
                });

                if ( notificationBar ) {
                    notificationBar.classList.add('active');
                }
            }
        };

        const setMobileNavPos = () => {
            const mobileHeader = document.querySelector('.main-nav-holder');
            if ( mobileHeader ) {
              const iMobileHeaderHeight = mobileHeader.getBoundingClientRect().bottom;
              if (document.querySelector('.nav-container')) {
                document.querySelector('.nav-container').style.top = iMobileHeaderHeight +'px';
              }
            }
        }

        window.addEventListener('scroll', setMainNavPos);
        window.addEventListener('scroll', () => window.setTimeout(setMobileNavPos, 300));

        window.addEventListener('resize', setMainNavPos);
        window.addEventListener('resize', setMobileNavPos);

        setMainNavPos();
        window.addEventListener('load', setMobileNavPos);
    }
}
